const OVERLAY_SCENE = 'camera-near-far-overlay-scene';

const EPSILON = 0.001;
const PLANE_WIDTH = 200; // px
const PLANE_HEIGHT = 4; // px

// Useful for debugging - displays the camera's near & far planes on the minimap.
export default class NearFarOverlay {
    constructor(topViewViewer, targetViewer) {
        this.topViewViewer = topViewViewer;
        this.targetViewer = targetViewer;

        this.topViewViewer.impl.createOverlayScene(OVERLAY_SCENE);

        this.planeGeometry = new THREE.PlaneBufferGeometry(1, 1);
        this.nearPlane = this.createMesh(0x005BCE);   // Blu-ish
        this.farPlane = this.createMesh(0xe8b22c);    // Yellow-ish

        this.show();
        this.update();

        this.update = this.update.bind(this);
        this.targetViewer.addEventListener(Autodesk.Viewing.RENDER_PRESENTED_EVENT, this.update);
        this.topViewViewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.update);
    }

    createMesh(color) {
        const material = new Autodesk.Viewing.Scene.UnlitMaterial({
            color,
            opacity: 1,
            transparent: false,
            depthTest: false,
            depthWrite: false,
            side: THREE.DoubleSide
        });

        const mesh = new THREE.Mesh(this.planeGeometry, material);

        return mesh;
    }

    show() {
        this.topViewViewer.impl.addOverlay(OVERLAY_SCENE, this.nearPlane);
        this.topViewViewer.impl.addOverlay(OVERLAY_SCENE, this.farPlane);
    }

    hide() {
        this.topViewViewer.impl.removeOverlay(OVERLAY_SCENE, this.nearPlane);
        this.topViewViewer.impl.removeOverlay(OVERLAY_SCENE, this.farPlane);
    }

    getScale(pixelSize) {
        const worldHeight = this.topViewViewer.getCamera().orthoScale;
        const viewport = this.topViewViewer.navigation.getScreenViewport();
        const scale = pixelSize * worldHeight / viewport.height;

        return scale;
    }

    update() {
        const camera = this.targetViewer.getCamera();

        const eyeDir = camera.target.clone().sub(camera.position).normalize();
        const angle = Math.atan2(camera.target.y - camera.position.y, camera.target.x - camera.position.x) + THREE.Math.degToRad(90);

        const pixelToWorld = this.getScale(1); // 1 pixel world scale
        const z = this.topViewViewer.getCamera().position.z - EPSILON;

        // Update near plane mesh
        const nearPos = camera.position.clone().add(eyeDir.clone().multiplyScalar(camera.near));
        nearPos.z = z;
        this.nearPlane.position.copy(nearPos);
        this.nearPlane.scale.set(pixelToWorld * PLANE_WIDTH, pixelToWorld * PLANE_HEIGHT, 1);
        this.nearPlane.rotation.set(0, 0, angle);

        // Update far plane mesh
        const farPos = camera.position.clone().add(eyeDir.clone().multiplyScalar(camera.far));
        farPos.z = z;
        this.farPlane.position.copy(farPos);
        this.farPlane.scale.set(pixelToWorld * PLANE_WIDTH, pixelToWorld * PLANE_HEIGHT, 1);
        this.farPlane.rotation.set(0, 0, angle);

        this.topViewViewer.impl.invalidate(false, false, true);
    }

    destroy() {
        this.planeGeometry.dispose();
        this.planeGeometry = null;

        this.topViewViewer.impl.removeOverlayScene(OVERLAY_SCENE);

        this.targetViewer.removeEventListener(Autodesk.Viewing.RENDER_PRESENTED_EVENT, this.update);
        this.topViewViewer.removeEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.update);

        this.topViewViewer = null;
        this.targetViewer = null;
    }
}
